// extracted by css-extract-rspack-plugin
export default {"button":"_2dc70eb7","frostedBackground":"_69bb0672","disabled":"_a10ff151","spinner":"_a3ed2c5c"};